<template lang="html">
  <section :id="id">
    <button-element
      v-for="(button, index) in buttons"
      :key="index"
      :id="button.id"
      :type="button.type"
      :text="button.text"
      :disabled="button.selected"
      :data="button"
      :border-style="getBorderStyle(index)"
      @on-button-click="onClick"
    />
  </section>
</template>

<script lang="js">
  import ButtonElement from "@/views/drag-drop-pages/components/ButtonElement";

  export default  {
    name: "group-buttons",
    components: {
      ButtonElement
    },
    props: {
      id: {
        type: String
      },
      buttons: {
        type: Array,
        default: () => []
      },
      disableSelected: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      onClick(ctx) {
        if(this.disableSelected) {
          this.buttons.forEach((e, index) => {
            e.selected = false;
            if(e.id === ctx.id) {
              e.selected = true;
            }
            this.$set(this.buttons, index, e);
          });
        }
        this.$emit("on-group-button-click", {id: this.id, button: ctx});
      },
      getBorderStyle(index) {
        let btnStyle = "center";
        if(!index) {
          btnStyle = "left";
        }
        if(index === this.buttons.length - 1) {
          btnStyle = "right";
        }
        return btnStyle;
      }
    }
  }
</script>
